<div class="container-fluid py-2 py-md-3 px-0">
  <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div>
      <h2 class="mb-0">Giochi</h2>
      <small class="text-muted">
        @if (isMine()) {
          I miei giochi
        } @else {
          Tutti i giochi
        }
      </small>
    </div>
    <div class="d-flex align-items-center gap-2 flex-wrap">
      @if (isAdmin()) {
        <button type="button" class="btn btn-primary" routerLink="/games/add"><i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Gioco</button>
      }
    </div>
  </div>

  @if (isLogged() && bggEnabled) {
    <app-bgg-bulk-import [showProviderSelector]="true" (importCompleted)="onBulkImportCompleted()"></app-bgg-bulk-import>
  }

  @if (isLoading()) {
    <div class="d-flex justify-content-center align-items-center py-5">
      <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;">
        <span class="visually-hidden">Caricamento giochi in corso...</span>
      </div>
    </div>
  } @else if (games().length > 0) {
    <app-paginated-list [items]="games()" [pageSize]="6">
      <ng-template let-game>
        <app-game-card
          [game]="game"
          (editGame)="onEditGame($event)"
          (deleteGame)="onDeleteGame($event)">
        </app-game-card>
      </ng-template>
    </app-paginated-list>
  } @else {
    <div class="container-generic text-center">
      <p class="message-error">Nessun gioco trovato</p>
    </div>
  }
</div>
